export const toJSon = arr => {
  const newJSon = {}
  for (let i = 0; i < arr.length; i++) {
    newJSon[arr[i].value] = arr[i].label
  }
  return newJSon
}

export const copyToClipboard = async content => {
  try {
    await navigator.clipboard.writeText(content)
  } catch (err) {
    console.error('复制失败', err)
  }
}
/**
 * 获取用户代理字符串的小写版本
 * @returns {string} 小写的用户代理字符串
 */
function getUserAgent() {
  return navigator.userAgent.toLowerCase()
}

/**
 * 检测是否为 Android 设备
 * @returns {boolean} 如果是 Android 设备则返回 true，否则返回 false
 */
export function isAndroid() {
  return /android/.test(getUserAgent())
}

/**
 * 检测是否为 iOS 设备
 * @returns {boolean} 如果是 iOS 设备则返回 true，否则返回 false
 */
export function isIOS() {
  return /iphone|ipad|ipod/.test(getUserAgent())
}

/**
 * 检测是否在微信内置浏览器中
 * @returns {boolean} 如果是在微信中打开则返回 true，否则返回 false
 */
export function isInWeChat() {
  return /micromessenger/.test(getUserAgent())
}

/**
 * 检测是否为 Safari 浏览器（排除 Chrome）
 * @returns {boolean} 如果是 Safari 浏览器则返回 true，否则返回 false
 */
export function isSafari() {
  const ua = navigator.userAgent
  return ua.includes('Safari') && !ua.includes('Chrome')
}

/**
 * 判断是否在微信小程序环境中（同步方法）
 * @returns {boolean} 如果在微信小程序环境中返回true，否则返回false
 */
export const isInWeChatMiniProgram = () => {
  const ua = window.navigator.userAgent.toLowerCase()

  // 方法1: 检查userAgent中是否包含miniprogram标识
  if (ua.includes('miniprogram')) {
    return true
  }

  // 方法2: 检查是否存在微信小程序特有的全局对象
  if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
    return true
  }

  // 方法3: 检查微信小程序API是否可用
  if (typeof wx !== 'undefined' && wx.getSystemInfoSync) {
    return true
  }

  // 方法4: 检查是否在微信环境中，并且可以访问微信小程序API
  if (ua.includes('micromessenger') && typeof wx !== 'undefined' && wx.miniProgram) {
    return true
  }

  return false
}

/**
 * 是否为 Flutter WebView 或微信小程序环境（站内 H5）
 * @returns {boolean}
 */
export function isFlutterOrWeChatMiniProgramEnv() {
  if (typeof window === 'undefined') return false
  const inFlutter = !!window.flutter_inappwebview
  return inFlutter || isInWeChatMiniProgram()
}

const MIME_TYPES = {
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  bmp: 'image/bmp',
  ico: 'image/x-icon',
}
export function getImageType(imageUrl) {
  if (!imageUrl) return 'image/jpg'
  if (imageUrl.startsWith('blob:')) return undefined
  console.log(imageUrl, 'imageUrl')
  // 提取纯净的后缀（忽略查询参数和哈希）
  const extension = imageUrl.split('.').pop().split(/[?#]/)[0].toLowerCase()
  const hasExtension = Object.keys(MIME_TYPES).includes(extension)

  return hasExtension ? MIME_TYPES[extension] : 'image/jpg'
}

/**
 * 判断是否在企业微信中
 * @returns {boolean}
 */
export function isInWeChatWork() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('wxwork')
}
/**
 * HTML实体解码函数
 * 将HTML实体编码转换为对应的Unicode字符
 * @param {string} str - 需要解码的字符串
 * @returns {string} 解码后的字符串
 */
export function decodeHtmlEntities(str) {
  if (!str || typeof str !== 'string') {
    return str
  }

  // 创建临时DOM元素来解码HTML实体
  const textarea = document.createElement('textarea')
  textarea.innerHTML = str
  return textarea.value
}
const TIME_UNIT_LABEL = {
  MINUTE: '分钟',
  HOUR: '小时',
  DAY: '天',
  MONTH: '月',
  YEAR: '年',
  CURRENT_DAY: '当天',
  CURRENT_MONTH: '当月',
}
/**
 * 将时间单位英文标识转换为中文
 * @param {string} val - 时间单位标识，如 'MINUTE', 'HOUR' 等
 * @returns {string} 对应的中文描述，未匹配时返回空字符串
 */
export const formatTimeUnit = val => {
  return TIME_UNIT_LABEL[val] || ''
}

export const isApp = (() => {
  const ua = navigator.userAgent.toLowerCase(),
    isFlutter = window.flutter_inappwebview ? true : false
  console.log('ua=========>', ua, ua.startsWith('ctg-zllx-'), 'isFlutterApp======>', isFlutter)
  return ua.startsWith('ctg-zllx-') || isFlutter
})()

/**
 * 格式化价格，去除尾部多余的0
 * @param {number|string} price - 价格值
 * @param {number} decimals - 保留小数位数，默认2位
 * @returns {string} 格式化后的价格字符串
 * @example
 * formatPrice(2222.20) // '2222.2'
 * formatPrice(2222.00) // '2222'
 * formatPrice(2222.25) // '2222.25'
 * formatPrice(0.10) // '0.1'
 */
export const formatPrice = (price, decimals = 2) => {
  if (price === null || price === undefined || price === '') {
    return '0'
  }
  
  const num = parseFloat(price)
  if (isNaN(num)) {
    return '0'
  }
  
  // 保留指定位数的小数
  const fixed = num.toFixed(decimals)
  
  // 去除尾部多余的0和小数点
  return parseFloat(fixed).toString()
}